import isServerSide from '../isServerSide'

import getCurrentMainDomain from './getCurrentMainDomain'

export default function getSubdomain() {
  if (isServerSide()) return null
  return String(window.location.hostname).slice(0, -(getCurrentMainDomain().length + 1))
}
